export default "__VITE_ASSET__D0D5wNyS__"